import React, { type ReactNode } from 'react';

import UFOSegment from '@atlaskit/react-ufo/ufo-segment';

import { NavigationExperienceId } from '../ufo-experience/constant';
import type { NavigationExperienceIdEnum } from '../ufo-experience/types';

export interface UseNavigationUFOSegmentProps {
	children: ReactNode;
	id: NavigationExperienceIdEnum;
}

/**
 * A wrapper component that provides UFO segment tracking for navigation components.
 * Uses the navigation experience IDs defined in the perf-utils constants.
 *
 * @param id - The experience ID from NavigationExperienceIdEnum
 * @param children - The child components to wrap
 */
export function NavigationUFOSegment({
	id,
	children,
}: UseNavigationUFOSegmentProps): React.JSX.Element {
	const experienceObj = NavigationExperienceId[id];

	return <UFOSegment name={experienceObj.experienceId}>{children}</UFOSegment>;
}
